/*
 * FILTER-UX01 (ТЗ v4 §19.1/§19.3, FE-FIX16): от выбора в ScopeFilter — к списку
 * камер, по которым экран строит панели/блоки.
 * Живёт рядом с фильтром, потому что нужен обеим вкладкам «Статистики»
 * (Ганта и общая) и завязан на форму уровней из useScopeOptions.
 */

/**
 * Камеры, по которым строятся панели, — только явно отмеченные.
 *
 * Выбранная локация без отмеченных камер панелей не даёт: раньше она
 * считалась «все камеры ветви», и пока пользователь ещё дощёлкивал до нужной
 * камеры, экран уже пересчитывал FTE по всем камерам локации.
 *
 * Имя берётся из загруженных опций, затем из когда-либо виденных (`known`):
 * черновик фильтра мог уйти в другую ветку, а применённая камера осталась.
 */
export const resolveScopeCameras = (scope, levels) => {
  const level = levels?.cameraIds;
  const byId = new Map((level?.options || []).map((option) => [option.id, option]));
  const known = level?.known || {};
  return (scope?.cameraIds || []).map((id) => {
    const option = byId.get(id) || known[id];
    return {
      id,
      name: option?.name || `Камера #${id}`,
      parentName: option?.parentName || '',
    };
  });
};
